<template>
  <div class="content-box2">
    <jContentBox :title="title">
      <div slot="headerRight" class="title-right" v-if="isShowHeader">
        <el-radio-group v-model="tabPosition" @change="change">
          <el-radio-button v-for="item in initRadios" :label="item" :key="item">{{item}}</el-radio-button>
        </el-radio-group>
      </div>
      <div slot="boxBody">
        <div class="body-title" v-show="isShow"><span class="title-name">{{bodyTitle}}:</span>
          <el-select v-model="value" placeholder="请选择" @change="selectChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <slot name="chartBox"></slot>
      </div>
    </jContentBox>
  </div>
</template>
<script>
  import jContentBox from './jContentBox.vue'
  export default{
    name: "contentBox2",
    components: {jContentBox},
    props: {
      title: {
        type: String,
        default: ''
      },
      initRadios: {
        type: Array,
        default: function () {
          return ['等级', '区域']
        }
      },
      initOptions: {
        type: Array,
        default: function () {
          return [{
            index: 0,
            value: '默认'
          }, {
            index: 1,
            value: '高>低'
          }, {
            index: 2,
            value: '低>高'
          }]
        }
      },
      initValue: {
        type: String,
        default: ''
      },
      initShow: {
        type: Boolean,
        default: true
      },
      initHeaderShow: {
        type: Boolean,
        default: true
      },
      initBodyTitle: {
        type: String,
        default: '排序'
      }
    },
    data(){
      return {
        tabPosition: this.initRadios[0],
        bodyTitle: this.initBodyTitle,
        options: this.initOptions,
        value: this.initValue || this.initOptions[0].value,
        isShow: this.initShow,
        isShowHeader: this.initHeaderShow
      }
    },
    methods: {
      change(val){
        this.$emit('change', val)
      },
      selectChange(val){
        this.$emit('selectChange', val)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .content-box2 {

  .title-right {
    display: inline-block;
    float: right;
    margin-right: 10px;
    /*margin-top: 4px;*/
  }

  .title-right /deep/ .el-radio-group {
    background-color: #071210;
    border-radius: 11px;
    border: solid 1px rgba(0, 248, 153, 0.3);
  }

  .title-right /deep/ .el-radio-button__inner {
    height: 20px;
    padding: 5px 20px;
  }

  .title-right /deep/ .el-radio-button .el-radio-button__inner {
    background: #002624;
    border-color: rgba(0, 248, 153, 0.3);
  }

  .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
    background: #009288;
  }

  .title-right /deep/ .el-radio-button .el-radio-button__inner {
    color: #a4cabd;
  }

  .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
    color: #ffffff;
  }

  .title-right /deep/ .el-radio-button:focus {
    box-shadow: 0 0 1px 1px rgba(0, 248, 153, 0.3);
  }

  .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:first-child:focus {
    border-top-left-radius: 11px;
    border-bottom-left-radius: 11px;
  }

  .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: none;
  }

  .title-right /deep/ .el-radio-button .el-radio-button__inner {
    line-height: 11px;
  }

  .title-right /deep/ .el-radio-button:last-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:last-child:focus {
    border-top-right-radius: 11px;
    border-bottom-right-radius: 11px;
  }

  .body-title {
    margin: 12px 14px;
  }

  .body-title /deep/ .el-input__inner {
    width: 92px;
    height: 22px;
    background-color: #002623;
    border-radius: 11px;
    border: 1px #00a2a1 solid;
    color: #d9eee7;
    font-size: 12px;
  }
    .body-title /deep/ .el-select__caret {
      color: #00a2a1;
    }
    .body-title /deep/ .el-input.is-focus {
      .el-input__inner {
        border-color: #00a2c0;
      }
    }
  .body-title .title-name {
    margin-left: 0;
    font-size: 12px;
    color: #bffffb;
  }

  }
</style>




// WEBPACK FOOTER //
// src/components/jContentBox2.vue